function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.05254 19.5595V23.6344L8.47544 25.7533L10.9204 29.1762H14.9953L18.5812 31.2952L22.1671 29.1762H26.242L28.5239 25.7533L32.4358 23.6344V19.5595L34.2287 15.6476L32.4358 11.8987L31.7838 7.4978L28.5239 5.86784L26.242 1.95595H22.1671L18.5812 0L14.9953 1.95595H10.9204L8.47544 5.86784L5.05254 7.4978V11.8987L2.93359 15.6476L5.05254 19.5595Z",
  fill: "#0F0F33"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.19383 26.2422L0 40.4228L7.4978 41.5638L12.8767 47.4316L19.7225 32.599H18.0925L14.8326 30.9691L9.61674 30.3171L8.14978 27.3832L6.19383 26.2422Z",
  fill: "#C91757"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8414 30.9691L19.0705 37.6519L23.7974 47.4316L29.1762 41.5638H37L29.9912 26.2422L27.3833 30.3171L21.8414 30.9691Z",
  fill: "#C91757"
});

var SvgBadges = function SvgBadges(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 48,
    viewBox: "0 0 37 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBadges, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Badges.89a60ced.svg";
export { ForwardRef as ReactComponent };